CC = {};
CC.CONST = {
  // LS_ (LS = localstorage)
  LS_REPORTSADD_RESULTS_LABEL: "cc_reports-add_results",
  LS_REPORTSADD_RESULT_SELECTED_LABEL: "cc_reports-add_result-select",
  LS_REPORTSADD_UI_EXTRAINFO_PANEL: "cc_ui_reports-add_openclose-panel",
  LS_ISSUESINDEX_UI_FILTERBARL: "cc_ui_issues-filterbar_openclose-panel",
  LS_STATSISSUESINDEX_UI_FILTERBARL: "cc_ui_stats-issues-filterbar_openclose-panel",
  LS_ISSUESINDEX_UI_UPDATEALERT: "cc_ui_issues-userupdate_openclose-alert",
  LS_ISSUESINDEX_FOUND_IDS: "cc_issues-ids_found",
  LS_ISSUESINDEX_AVAILABLE_IDS: "cc_issues-ids_available",
  LS_ISSUESDETAIL_OPEN_HISTORY_IDS: "cc_issues-detail-open-history",
  LS_ISSUESDETAIL_UI_REPORTS: "cc_ui_issues-detail-reports_openclose-panel",
  LS_SETTINGSAUTOMATIONS_UI_HOWTOALERT: "cc_ui_settings-automations_openclose-alert",
  LS_SETTINGSAUTOMATIONSMODAL_UI_HOWTOALERT: "cc_ui_settings-automations-modal_openclose-alert",
  LS_SETTINGSPOLYGONS_UI_HOWTOALERT: "cc_ui_settings-polygons_openclose-alert",
  LS_APPINDEX_UI_EXTRAINFO_PANEL: "cc_ui_app-index_openclose-alert",
  LS_SETTINGSCRM_UI_PINNEDUSERS: "cc_ui_settings-crm_pinned-users",
  LS_SETTINGS_LAST_USED_GEOAREA_ID: "cc_ui_settings-last_used_geoarea_id",
  LS_REPORTSADD_PREFERENCES_LAST_SOURCE_ID: "cc_reports-add_prefs_last_source_id"
};
CC.DATA = {
  ajax: {
    saving: 0,
    loading: 0,
    saved: 0,
    error: 0
  },
  store: {
    set: function (label, value) {
      console.log("LS: store label: " + label + ", with value: " + value);
      localStorage.setItem(label, JSON.stringify(value));
    },
    get: function (label) {
      value = JSON.parse(localStorage.getItem(label));
      console.log("LS: get label: " + label + ", with value: " + value);
      return value;
    },
    append: function (label, additionalValue) {
      value = JSON.parse(localStorage.getItem(label));
      if (value == null) {  // first time
        value = new Array();
      }
      if (value instanceof Array) {
        value.push(additionalValue);
      }
      localStorage.setItem(label, JSON.stringify(value));
    },
    remove: function (label) {
      console.log("LS: remove label: " + label);
      localStorage.removeItem(label);
    }
  }
};
CC.EVENTS = {
  input: {
    onEnterSave: function (query) {
      /**
       * This method want jquery objects
       */
      $(query).each(function () {
        $(this).keydown(function (e) {
          var callback;
          $this = $(this);
          if ($this.is("input")) {
            if ((event.keyCode == 13) || ((event.metaKey || event.ctrlKey) && event.keyCode == 13)) {
              callback = $(this).data("cc-onentersave");
            }
          } else if ($this.is("textarea")) {
            if ((event.metaKey || event.ctrlKey) && event.keyCode == 13) {
              callback = $(this).data("cc-onentersave");
            }
          }
          if (callback) {
            eval(callback);
          }
        })
      });
    },
    onEscAbort: function (query) {
      /**
       * This method want jquery objects
       */
      $(query).each(function () {
        $(this).keyup(function (e) {
          if (e.keyCode == 27 || e.which == 27) {
            callback = $(this).data("cc-onescabort");
            eval(callback);
          }
        })
      });
    },
    onKeyUpFilter: function (what, where, emptyPlaceholderDivId) {
      /**
       * Bind this event to a input field to filter a set of <li>
       */
      hiddenCounter = 0;
      shownCounter = 0;
      what = what.toLowerCase().trim();
      if (what.length > 0) {
        $(where).each(function () {
          var mapName = $(this).data("filterable_content").toLowerCase();
          if (mapName.indexOf(what) != -1) {
            $(this).removeClass("d-none");
            shownCounter++;
          } else {
            $(this).addClass("d-none");
            hiddenCounter++;
          }
        })
      } else {
        $(where).each(function () {
          $(this).removeClass("d-none");
          shownCounter++;
        });
      }

      if (emptyPlaceholderDivId) {
        if (shownCounter == 0) {
          $("#" + emptyPlaceholderDivId).removeClass("d-none");
        } else {
          $("#" + emptyPlaceholderDivId).addClass("d-none");
        }
      }

      return false;
    }
  }
};
CC.UI = {
  dashboard: {
    showActivitiesPanel: function () {
      return;
    },
    hideActivitiesPanel: function () {
      return;
    }
  },
  generic: {
    showHiddenFields: function () {
      $("input[type='hidden']").each(function () {
        var name = $(this).attr('name'); // grab name of original
        var value = $(this).attr('value'); // grab value of original
        /* create new visible input */
        var html = '<input id="' + $(this).attr('id') + '" type="text" name="' + name + '" value="' + value + '" />';
        $(this).after(html).remove(); // add new, then remove original input
      });
    },
    showOverlayLoader: function () {
      $('.spinner-overlay').removeClass('d-none');
    }
  },
  bs4: {
    tooltip: {
      enable: function () {
        $(function () {
          $('[data-toggle="tooltip"]:not(.tooltip-disabled)').tooltip({
            template: '<div class="tooltip" role="tooltip"><div class="arrow tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
          })
        });
      }
    },
    popover: {
      hideAll: function () {
        $('.popover').popover('hide');
        $('.popover-ready').popover('hide');
      }
    }
  },
  bs5: {
    tooltip: {
      enable: function () {
        const tooltipTriggerList = [].slice.call(
          document.querySelectorAll('[data-bs-toggle="tooltip"]:not(.tooltip-disabled)')
        );
        tooltipTriggerList.forEach(function (tooltipTriggerEl) {
          new bootstrap.Tooltip(tooltipTriggerEl, {
            template:
              '<div class="tooltip" role="tooltip">' +
              '<div class="tooltip-arrow"></div>' +
              '<div class="tooltip-inner"></div>' +
              '</div>'
          });
        });
      }
    },
    popover: {
      hideAll: function () {
        document.querySelectorAll('.popover').forEach(function (popoverEl) {
          const popoverInstance = bootstrap.Popover.getInstance(popoverEl);
          if (popoverInstance) popoverInstance.hide();
        });
      }
    }
  },
  chat: {
    embed: function (targetDivID, issueHexaID, channelIDS) {
      var url = "/issues/$issueHexID/messages?channel_ids=$channelIDS";
      url = url.replace("$issueHexID", issueHexaID);
      url = url.replace("$channelIDS", channelIDS);
      $(targetDivID).load(url);
    },
    refresh: function (label) {
      console.log('refresh debug ' + label);
      if (label == "internal") {
        if (typeof (refreshChat___1) !== "undefined") {
          refreshChat___1();
        }
      } else if (label == "external") {
        if (typeof (refreshChat___2) !== "undefined") {
          refreshChat___2();
        }
      } else {
        console.error("error, cant refresh. unknown label provided: " + label);
      }
    }
  },
  textarea: {
    autosize: function () {
      $('textarea.cc-textarea-wanna-be-autoresize').bind('keyup keypress', function () {
        $(this).height('');
        var brCount = this.value.split('\n').length;
        this.rows = brCount + 1; //++ To remove twitching
        var areaH = this.scrollHeight,
          lineHeight = $(this).css('line-height').replace('px', ''),
          calcRows = Math.floor(areaH / lineHeight);
        this.rows = calcRows;
        $(this).removeClass("cc-textarea-wanna-be-autoresize");
        $(this).addClass("cc-textarea-autoresize");
      });
    }
  },
  status: {
    saving: function () {
      if ((CC.DATA.ajax.saving - (CC.DATA.ajax.saved + CC.DATA.ajax.error)) == 0) {
        // var n = noty({
        //   layout: 'topCenter',
        //   type: 'warning',
        //   text: 'Saving ...',
        //   animation: {
        //       open: {height: 'toggle'},     // jQuery animate function property object
        //       close: {height: 'toggle'},    // jQuery animate function property object
        //       easing: 'swing',              // easing
        //       speed: 500                    // opening & closing animation speed
        //   }
        // });
        new Noty({
          theme: 'bootstrap-v4',
          layout: 'topCenter',
          type: 'warning',
          text: lblNotySaving,
        }).show();
      }
      CC.DATA.ajax.saving = CC.DATA.ajax.saving + 1;
    },
    /**
     * The same as "saving", but with different label
     * @return {[type]} [description]
     */
    loading: function () {
      // to do yet
      if ((CC.DATA.ajax.loading - (CC.DATA.ajax.loading + CC.DATA.ajax.error)) == 0) {
        new Noty({
          theme: 'bootstrap-v4',
          layout: 'topCenter',
          type: 'warning',
          text: lblNotyLoading,
        }).show();
      }
      CC.DATA.ajax.loading = CC.DATA.ajax.loading + 1;
    },
    done: function () {
      // to do yet
      return;
    },
    saved: function () {
      CC.DATA.ajax.saved = CC.DATA.ajax.saved + 1;
      if ((CC.DATA.ajax.saved - CC.DATA.ajax.saving - CC.DATA.ajax.error) == 0) {
        new Noty({
          theme: 'bootstrap-v4',
          layout: 'topCenter',
          type: 'success',
          text: lblNotySaved,
          killer: true,
          timeout: 1000
        }).show();
      }
    },
    fail: function () {
      CC.DATA.ajax.error = CC.DATA.ajax.error + 1;
      new Noty({
        theme: 'bootstrap-v4',
        layout: 'topCenter',
        type: 'error',
        text: lblNotyFail,
        killer: true,
        timeout: 2500
      }).show();
    },
    forbidden: function () {
      CC.DATA.ajax.error = CC.DATA.ajax.error + 1;
      new Noty({
        theme: 'bootstrap-v4',
        layout: 'topCenter',
        type: 'error',
        text: lblNotyForbidden,
        killer: true,
        timeout: 2500
      }).show();
    },
    unauthorized: function () {
      console.log('unauthorized');
    },
    notfound: function () {
      console.log('notfound');
    }
  }
};
CC.REST = {
  private: {
    users: {
      getBadge: function (
        userId,
        popoverParentId,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.users.getBadge()");
        if (userId != null) {
          var url = "/rest/private/users/$userId/badge";
          url = url.replace("$userId", userId);
          $.ajax({
            type: "GET",
            url: url,
            contentType: "application/json",
            dataType: "json",
          })
            .done(function (data, popoverParentId) {
              successCallback.call(this, data);
            })
            .fail(function (data) {
              errorCallback.call(this, data);
            });
        }
      },
    },
    mentions: {
      setAsDone: function (mentionId, successCallback, errorCallback) {
        console.debug(arguments, "CC.REST.private.mentions.setAsDone()");
        var url = "/rest/private/todos/mentions/$mentionId/done";
        url = url.replace("$mentionId", mentionId);
        // var data = {
        //   text: text
        // };
        // data = JSON.stringify(data);
        $.ajax({
          type: "POST",
          url: url,
          // data: data,
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            successCallback.call(this, data);
          })
          .fail(function (data) {
            errorCallback.call(this, data);
          });
      },
    },
    chat: {
      send: function (
        issueHexId,
        channelId,
        text,
        isReplyEnabled,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.chat.send()");
        if (text.length == 0) {
          return;
        }
        url = "/rest/private/chat/$issueHexID/channel/$channelID/send";
        url = url.replace("$issueHexID", issueHexId);
        url = url.replace("$channelID", channelId);
        var data = {
          text: text,
          isReplyEnabled: isReplyEnabled,
        };
        data = JSON.stringify(data);
        $.ajax({
          type: "POST",
          url: url,
          data: data,
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            successCallback.call(this, data);
          })
          .fail(function (data) {
            errorCallback.call(this, data);
          });
      },
      refresh: function (
        issueHexId,
        channelId,
        lastChatId,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.chat.refresh()");
        url =
          "/rest/private/chat/$issueHexID/channel/$channelID/last/$lastChatId/refresh";
        url = url.replace("$issueHexID", issueHexId);
        url = url.replace("$channelID", channelId);
        url = url.replace("$lastChatId", lastChatId);
        if (lastChatId > 0) {
          $.get(url).done(function (data) {
            successCallback.call(this, data);
          });
        } else {
          console.warn("No lastChatId valid provided");
        }
        // .fail(function(data) {
        //   errorCallback.call(this, data);
        // })
      },
    },
    connect: {
      fbshare: function (
        connectID,
        fbPageID,
        fbPostID,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.connect.fbshare()");
        url = "/rest/private/connect/$connectID/fb_share/$fbPageID/$fbPostID";
        url = url.replace("$connectID", connectID);
        url = url.replace("$fbPostID", fbPostID);
        url = url.replace("$fbPageID", fbPageID);
        CC.UI.status.saving();
        $.post(url)
          .done(function (data) {
            CC.UI.status.saved();
            successCallback.call(this, data);
          })
          .fail(function (data) {
            errorCallback.call(this, data);
          });
      },
      deleteAttachment: function (
        signature,
        connectID,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.connect.deleteAttachment()");
        var signatureArray = signature.split(":");
        var attachmentUUID = "";
        if (signatureArray.length == 2) {
          attachmentUUID = signatureArray[1];
        }
        var url = "/connect/$connectID/attachments/$attachmentUUID/delete";
        url = url.replace("$connectID", connectID);
        url = url.replace("$attachmentUUID", attachmentUUID);
        var data = {
          attachment_signature: signature,
        };
        $.ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
    },
    plannings: {
      // Function to send a POST request
      sendDone: function (url) {
        new Noty({
          theme: 'bootstrap-v4',
          layout: 'topCenter',
          type: 'warning',
          text: lblNotyLoading,
        }).show();

        $.ajax({
          type: "POST",
          url: url,
          contentType: "application/json",
          dataType: "json",
        }).done(function (data) {
          new Noty({
            theme: 'bootstrap-v4',
            layout: 'topCenter',
            type: 'success',
            text: lblNotySaved,
            killer: true,
            timeout: 1000
          }).show();
        }).fail(function (data) { });
      }
    },
    issues: {
      lastActivities: function (issueIDS, successCallback, errorCallback) {
        console.debug(arguments, "CC.REST.private.issues.lastActivities()");
        url = " /rest/private/users/me/issues/$issueIDS/last_activities";
        url = url.replace("$issueIDS", issueIDS);
        $.get(url)
          .done(function (data) {
            console.debug("success", data);
            successCallback.call(this, data);
          })
          .fail(function (data) {
            console.error("error", data);
            errorCallback.call(this, data);
          });
      },
      externalMail: function (
        issueHexaID,
        fromUserID,
        to,
        cc,
        body,
        attachments,
        expireInMinutes,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.issues.externalMail()");
        url = " /rest/private/issues/$issueHexaID/external_email/$userID/send";
        url = url.replace("$issueHexaID", issueHexaID);
        url = url.replace("$userID", fromUserID);
        if (attachments.length) {
          attachments = attachments.join(";")
        }

        var data = {
          to: to,
          cc: cc,
          body: body,
          from_user_id: fromUserID,
          attachments: attachments,
          expire_in_minutes: expireInMinutes
        };
        CC.UI.status.saving();
        $.ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            CC.UI.status.saved();
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            CC.UI.status.fail();
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
      markAsRead: function (issueID, successCallback, errorCallback) {
        console.debug(arguments, "CC.REST.private.issues.markAsRead()");
        url = "/rest/private/issues/$issueID/mark_as_read";
        url = url.replace("$issueID", issueID);
        // CC.UI.status.saving();
        $.get(url)
          .done(function (data) {
            CC.UI.status.saved();
            console.debug("success", data);
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            CC.UI.status.fail();
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
      toggleAssigned: function (
        issueHexaID,
        toUserID,
        fromUserID,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.issues.toggleAssigned()");
        url = "/rest/private/issues/$issueHexaID/assign_to/$toUserID/toggle";
        url = url.replace("$issueHexaID", issueHexaID);
        url = url.replace("$toUserID", toUserID);
        var data = {
          from_user_id: fromUserID,
        };
        CC.UI.status.saving();
        $.ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            CC.UI.status.saved();
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            CC.UI.status.fail();
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
      updateField: function (
        issueID,
        field,
        value,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.issues.updateField()");
        var url = "/rest/private/issues/$issueID/update";
        url = url.replace("$issueID", issueID);
        var data = {
          field: field,
          value: value,
        };
        CC.UI.status.saving();
        $.ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            CC.UI.status.saved();
            CC.UI.chat.refresh("internal");
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
      getPreview: function (issueID, successCallback, errorCallback) {
        url = "/rest/private/issues/$issueID/preview";
        url = url.replace("$issueID", issueID);
        $.ajax({
          type: "GET",
          url: url,
          contentType: "application/json",
        })
          .done(function (data) {
            console.debug("success", data);
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
      moveReport: function (
        reportID,
        fromIssueID,
        toIssueID,
        successCallback,
        errorCallback
      ) {
        /**
         * /rest/private/reports/<report_id>/from/<issue_id_from>/to/<issue_id_to>/move
         */
        var url =
          "/rest/private/reports/$reportID/from/$fromIssueID/to/$toIssueID/move";
        url = url.replace("$reportID", reportID);
        url = url.replace("$fromIssueID", fromIssueID);
        url = url.replace("$toIssueID", toIssueID);
        CC.UI.status.saving();
        $.ajax({
          type: "POST",
          url: url,
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            // console.log('move done');
            CC.UI.status.saved();
            // console.log(successCallback);
            if (successCallback) {
              // console.log('successCallback call');
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            CC.UI.status.fail();
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
      editReporter: function (
        reportID,
        issueID,
        crmID,
        isWithCrmUpdate,
        firstName,
        lastName,
        email,
        phone,
        cf,
        successCallback,
        errorCallback
      ) {
        var url = "/rest/private/issues/$issueID/reports/$reportID/update";
        url = url.replace("$reportID", reportID);
        url = url.replace("$issueID", issueID);
        var data = {
          first_name: firstName,
          last_name: lastName,
          phone: phone,
          email: email,
          crm_id: crmID,
          is_with_crm_update: isWithCrmUpdate,
        };
        if (cf) {
          data["cf"] = cf;
        }

        CC.UI.status.saving();
        $.ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            CC.UI.status.saved();
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            CC.UI.status.fail();
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
    },
    feedback: {
      addFeedback: function (
        geoarea_id,
        score,
        userID,
        email,
        source,
        mainCategory,
        subCategory,
        description,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.feedback.addFeedback()");
        url = "/rest/private/feedback/add";
        var data = {
          geoarea_id: geoarea_id,
          score: score,
          source: source,
          main_category: mainCategory,
          sub_category: subCategory,
          description: description,
        };
        if (userID) {
          data["user_id"] = userID;
        }
        if (email) {
          data["email"] = email;
        }
        CC.UI.status.saving();
        $.ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            CC.UI.status.saved();
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            CC.UI.status.fail();
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
    },
    reports: {
      deleteDraft: function (
        signature,
        geoareaID,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.reports.deleteDraft()");
        var signatureArray = signature.split(":");
        var attachmentUUID = "";
        if (signatureArray.length == 2) {
          attachmentUUID = signatureArray[1];
        }
        var url = "/reports/$geoareaID/attachments/$attachmentUUID/delete";
        url = url.replace("$geoareaID", geoareaID);
        url = url.replace("$attachmentUUID", attachmentUUID);
        var data = {
          attachment_signature: signature,
        };
        $.ajax({
          type: "POST",
          url: url,
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
      addMissingAddress: function (
        address,
        latitude,
        longitude,
        geoareaId,
        postalCode,
        adminArea,
        subAdminArea,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.reports.send()");
        url = "/rest/private/pois/add";
        var data = {
          address: address,
          latitude: latitude,
          longitude: longitude,
          geoareaId: geoareaId,
          postalCode: postalCode,
          adminArea: adminArea,
          subAdminArea: subAdminArea,
        };
        data = JSON.stringify(data);
        $.ajax({
          type: "POST",
          url: url,
          data: data,
          contentType: "application/json",
          dataType: "json",
        })
          .done(function (data) {
            successCallback.call(this, data);
          })
          .fail(function (data) {
            errorCallback.call(this, data);
          });
      },
    },
    crm: {
      searchUser: function (
        geoareaID,
        searchTerm,
        successCallback,
        errorCallback
      ) {
        console.debug(arguments, "CC.REST.private.crm.searchUser()");
        var url = "/rest/private/$geoareaID/crm/users/$searchTerm/search";
        url = url.replace("$geoareaID", geoareaID);
        url = url.replace("$searchTerm", searchTerm);
        $.ajax({
          type: "GET",
          url: url,
          contentType: "application/json",
        })
          .done(function (data) {
            console.debug("success", data);
            if (successCallback) {
              successCallback.call(this, data);
            }
          })
          .fail(function (data) {
            console.error("error", data);
            if (errorCallback) {
              errorCallback.call(this, data);
            }
          });
      },
    },
    settings: {
      categoriesPermissions: {
        typeOfInsertList: function (
          userID,
          isEnabled,
          successCallback,
          errorCallback
        ) {
          console.debug(
            arguments,
            "CC.REST.private.settings.categoriesPermissions.typeOfInsertList()"
          );
          url =
            "/rest/private/user/$userID/categories_permission/type_of_insert_list/$isEnabled";

          url = url.replace("$userID", userID);
          url = url.replace("$isEnabled", isEnabled);

          CC.UI.status.saving();
          $.post(url)
            .done(function (data) {
              CC.UI.status.saved();
              successCallback.call(this, data);
            })
            .fail(function (data) {
              errorCallback.call(this, data);
            });
        },
      },
      problemTypesPermissions: {
        update: function (
          userID,
          problemTypeID,
          isEnabled,
          successCallback,
          errorCallback
        ) {
          console.debug(
            arguments,
            "CC.REST.private.settings.problemTypesPermissions.update()"
          );
          if (problemTypeID == "all") {
            url =
              "/rest/private/user/$userID/edit/type_permission/all/$isEnabled";
          } else {
            url =
              "/rest/private/user/$userID/edit/type_permission/$problemTypeID/$isEnabled";
            url = url.replace("$problemTypeID", problemTypeID);
          }

          url = url.replace("$userID", userID);
          url = url.replace("$isEnabled", isEnabled);

          CC.UI.status.saving();
          $.get(url)
            .done(function (data) {
              CC.UI.status.saved();
              successCallback.call(this, data);
            })
            .fail(function (data) {
              errorCallback.call(this, data);
            });
        },
      },
      teams: {
        modifyUsersInTeam: function (
          action,
          geoareaID,
          userID,
          teamID,
          successCallback,
          errorCallback
        ) {
          console.debug(
            arguments,
            "CC.REST.private.settings.teams.modifyUsersInTeam()"
          );
          url = "/rest/private/settings/$geoareaID/teams/$action";
          url = url.replace("$geoareaID", geoareaID);
          url = url.replace("$action", action);
          var data = {
            user_id: userID,
            team_id: teamID,
            action: action,
          };
          CC.UI.status.saving();
          $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json",
          })
            .done(function (data) {
              CC.UI.status.saved();
              if (successCallback) {
                successCallback.call(this, data);
              }
            })
            .fail(function (data) {
              CC.UI.status.fail();
              console.error("error", data);
              if (errorCallback) {
                errorCallback.call(this, data);
              }
            });
        },
      },
      polygons: {
        updatePolygonsOrder: function (
          polygonOrderedIds,
          geoareaID,
          successCallback,
          errorCallback
        ) {
          console.debug(
            arguments,
            "CC.REST.private.settings.polygons.updatePolygonsOrder()"
          );
          url = "/rest/private/settings/$geoareaID/polygons/reorder";
          url = url.replace("$geoareaID", geoareaID);
          var data = {
            polygon_ordered_ids: polygonOrderedIds,
          };
          CC.UI.status.saving();
          $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json",
          })
            .done(function (data) {
              CC.UI.status.saved();
              if (successCallback) {
                successCallback.call(this, data);
              }
            })
            .fail(function (data) {
              CC.UI.status.fail();
              console.error("error", data);
              if (errorCallback) {
                errorCallback.call(this, data);
              }
            });
        },
      },
    },
    app: {
      dashboard: {
        removeAppContent: function (
          geoareaID,
          structureID,
          contentID,
          successCallback,
          errorCallback
        ) {
          console.debug(
            arguments,
            "CC.REST.private.app.dashboard.removeAppContent()"
          );
          url = "/rest/private/app/$geoareaID/remove";
          url = url.replace("$geoareaID", geoareaID);
          var data = {
            structure_id: structureID,
            content_id: contentID,
          };
          CC.UI.status.saving();
          $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json",
          })
            .done(function (data) {
              CC.UI.status.saved();
              if (successCallback) {
                successCallback.call(this, data);
              }
            })
            .fail(function (data) {
              CC.UI.status.fail();
              console.error("error", data);
              if (errorCallback) {
                errorCallback.call(this, data);
              }
            });
        },
        updateStructureConf: function (
          geoareaID,
          structureType,
          structureStatus,
          isActive,
          successCallback,
          errorCallback
        ) {
          console.debug(
            arguments,
            "CC.REST.private.app.dashboard.updateStructureConf()"
          );
          url = "/rest/private/app/$geoareaID/update";
          url = url.replace("$geoareaID", geoareaID);
          var data = {
            structure_type: structureType,
            structure_status: structureStatus,
            is_active: isActive,
          };
          CC.UI.status.saving();
          $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json",
          })
            .done(function (data) {
              CC.UI.status.saved();
              if (successCallback) {
                successCallback.call(this, data);
              }
            })
            .fail(function (data) {
              CC.UI.status.fail();
              console.error("error", data);
              if (errorCallback) {
                errorCallback.call(this, data);
              }
            });
        },
      },
    },
    resources: {
      maps: {
        removePoiFromMap: function (
          geoareaID,
          mapID,
          poiID,
          successCallback,
          errorCallback
        ) {
          console.debug(
            arguments,
            "CC.REST.private.resources.maps.removePoiFromMap()"
          );
          url = "/rest/private/resources/$geoareaID/maps/$mapID/remove";
          url = url.replace("$geoareaID", geoareaID);
          url = url.replace("$mapID", mapID);
          var data = {
            poi_id: poiID,
          };
          CC.UI.status.saving();
          $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json",
          })
            .done(function (data) {
              CC.UI.status.saved();
              if (successCallback) {
                successCallback.call(this, data);
              }
            })
            .fail(function (data) {
              CC.UI.status.fail();
              console.error("error", data);
              if (errorCallback) {
                errorCallback.call(this, data);
              }
            });
        },
      },
    },
  },
};
CC.BOOT = {
  defer: function (method) {
    if (window.jQuery) {
      method();
    } else {
      setTimeout(function () { CC.BOOT.defer(method) }, 50);
    }
  },
};
CC.SEC = {
  purify: function (dirty, args) {
    return DOMPurify.sanitize(dirty, { SAFE_FOR_JQUERY: true })
  }
};

/* ========================================================== */
/* ========================================================== */
/* ========================================================== */
/* ========================================================== */
/* ========================================================== */
$.ajaxSetup({
  beforeSend: function (xhr, settings) {
    if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type) && !this.crossDomain) {
      var csrftoken = $('meta[name=csrf-token]').attr('content');
      xhr.setRequestHeader("X-CSRFToken", csrftoken);
    }
  }
});

// ====================================
// ========== Ajax Prefilter ==========
// ====================================
$.ajaxPrefilter(function (opts, originalOpts, jqXHR) {
  // you could pass this option in on a "retry" so that it doesn't
  // get all recursive on you.
  if (opts.refreshRequest) {
    return;
  }

  // our own deferred object to handle done/fail callbacks
  var dfd = $.Deferred();

  // if the request works, return normally
  jqXHR.done(dfd.resolve);

  // if the request fails, do something else
  // yet still resolve
  jqXHR.fail(function () {
    var args = Array.prototype.slice.call(arguments);
    console.debug('prefilter fail catched (1)', jqXHR);
    console.debug('prefilter fail catched (2)', args);

    var isResponseIgnorable = false;
    if (jqXHR.status === 0) {
      isResponseIgnorable = true;
    } else if (jqXHR.status === '') {
      isResponseIgnorable = true;
    }

    if (jqXHR.readyState === 0) {
      isResponseIgnorable = true;
    }

    if (!isResponseIgnorable) {
      if (jqXHR.status === 401) {
        // todo
      } else if (jqXHR.status === 403) {
        // forbidden error
        CC.UI.status.forbidden();
        dfd.rejectWith(jqXHR, args);
      } else {
        // not handled error code
        CC.UI.status.fail();
        dfd.rejectWith(jqXHR, args);
      }
    }
  });

  // NOW override the jqXHR's promise functions with our deferred
  return dfd.promise(jqXHR);
});

$.urlParam = function (name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results == null) {
    return null;
  }
  else {
    return decodeURI(results[1]) || 0;
  }
};

var decodeHTML = function (html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

// retain global variable after obfuscator step
window.decodeHTML = decodeHTML;
